import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  resetFilters
} = translate({
  "resetFilters": "Reset filters"
});
export const activeFilters = translateFormatter<{
  activeFilters: number;
}>([{
  "type": 2,
  "value": "activeFilters",
  "style": null
}, {
  "type": 0,
  "value": " "
}, {
  "type": 6,
  "value": "activeFilters",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "filter activated"
      }]
    },
    "other": {
      "value": [{
        "type": 0,
        "value": "filters activated"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");